import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { TimelineEventSource } from '../../../models/TimelineEvent';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface SourceSelectorProps {
  sources: TimelineEventSource[];
  currentIndex: number;
  onSelect: (index: number) => void;
}

export default function SourceSelector({ sources, currentIndex, onSelect }: SourceSelectorProps) {
  const { t } = useTranslation();

  if (!sources || sources.length <= 1) return null;

  return (
    <div className="flex items-center justify-between bg-muted/30 p-2 rounded-md mb-3 border border-border/50">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onSelect(Math.max(0, currentIndex - 1))}
        disabled={currentIndex === 0}
        className="h-8 w-8 p-0"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>

      <div className="flex flex-col items-center">
        <span className="text-sm font-medium">
          {t('common.timeline.documentViewer.sourceNofM', {
            current: currentIndex + 1,
            total: sources.length
          })}
        </span>
        <span className="text-[10px] text-muted-foreground truncate max-w-[200px]">
          {/* Can show snippets here if needed */}
        </span>
      </div>

      <Button
        variant="ghost"
        size="sm"
        onClick={() => onSelect(Math.min(sources.length - 1, currentIndex + 1))}
        disabled={currentIndex === sources.length - 1}
        className="h-8 w-8 p-0"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}




